/* Flavourite Wine, feedbackpunt 40: zonder 18+ vinkje geen checkout.

   flav-leeftijd-gate-p1: dit stond eerst als inline script in
   snippets/cart-summary.liquid. Dat snippet rendert alleen bij een gevulde mand,
   dus wie een pagina opende met een lege mand, daarna iets toevoegde en via de
   lade ging afrekenen, had het script nooit geladen: de lade krijgt zijn nieuwe
   inhoud via een morph, en scripts die zo binnenkomen worden niet uitgevoerd.
   Daarom nu een los bestand dat op elke pagina laadt (layout/theme.liquid).

   Bewust op click in de capture-fase, zodat we voor de Horizon-componenten
   zitten. Eén gedelegeerde luisteraar op document, zodat het ook werkt voor de
   drawer, die na elke cartwijziging opnieuw wordt gerenderd. */
(function () {
  if (window.flavLeeftijdGate) return;
  window.flavLeeftijdGate = true;

  function blok(el) {
    return el && el.closest ? el.closest('.cart-drawer, .cart, body') : null;
  }

  function velden(knop) {
    var wortel = blok(knop) || document;
    var wrap = wortel.querySelector('[data-flav-cart-legal]');
    if (!wrap) {
      // Val terug op het dichtstbijzijnde blok in dezelfde container.
      wrap = document.querySelector('[data-flav-cart-legal]');
    }
    if (!wrap) return null;
    return {
      wrap: wrap,
      vink: wrap.querySelector('[data-flav-18]'),
      fout: wrap.querySelector('[data-flav-18-fout]')
    };
  }

  document.addEventListener('click', function (e) {
    var knop = e.target && e.target.closest ? e.target.closest('#checkout, [name="checkout"]') : null;
    if (!knop) return;
    var v = velden(knop);
    if (!v || !v.vink || v.vink.checked) return;
    // flav-cart-sync-p1: een verborgen vinkje (geen alcohol in de mand) blokkeert niet.
    var blok18 = v.vink.closest('[data-flav-18-blok]');
    if (blok18 && blok18.hidden) return;
    e.preventDefault();
    e.stopPropagation();
    if (v.fout) v.fout.hidden = false;
    v.wrap.classList.add('is-fout');
    v.vink.focus();
  }, true);

  document.addEventListener('change', function (e) {
    var vink = e.target && e.target.matches && e.target.matches('[data-flav-18]') ? e.target : null;
    if (!vink || !vink.checked) return;
    var wrap = vink.closest('[data-flav-cart-legal]');
    if (!wrap) return;
    var fout = wrap.querySelector('[data-flav-18-fout]');
    if (fout) fout.hidden = true;
    wrap.classList.remove('is-fout');
  });
})();
